import React from "react";

interface HomeIconProps {
  color?: string;
  className?: string;
}

export const HomeIcon: React.FC<HomeIconProps> = ({ color, className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path
          d="M4.72105 16.1121H7.94062V11.6025C7.94062 11.4338 7.99714 11.293 8.11018 11.1799C8.22322 11.0669 8.36408 11.0104 8.53276 11.0104H11.4815C11.6391 11.0104 11.7747 11.0669 11.8885 11.1799C12.0023 11.293 12.0592 11.4338 12.0592 11.6025V16.1121H15.2787V8.30818C15.2787 8.26544 15.2694 8.22671 15.2507 8.19199C15.232 8.15727 15.2066 8.12655 15.1746 8.09984L10.1521 4.32849C10.1094 4.29643 10.0587 4.28041 9.99989 4.28041C9.94112 4.28041 9.89037 4.29643 9.84764 4.32849L4.82522 8.09984C4.79317 8.12655 4.76779 8.15727 4.7491 8.19199C4.7304 8.22671 4.72105 8.26544 4.72105 8.30818V16.1121ZM3.80762 16.1121V8.31566C3.80762 8.12423 3.84623 7.94821 3.92345 7.78761C4.00067 7.62703 4.11911 7.49161 4.27876 7.38136L9.30118 3.59453C9.50614 3.43748 9.73846 3.35895 9.99816 3.35895C10.2579 3.35895 10.4913 3.43748 10.6986 3.59453L15.721 7.38136C15.8807 7.49161 15.9991 7.62703 16.0763 7.78761C16.1535 7.94821 16.1922 8.12423 16.1922 8.31566V16.1121C16.1922 16.3604 16.102 16.5747 15.9216 16.755C15.7413 16.9354 15.527 17.0256 15.2787 17.0256H11.7379C11.5692 17.0256 11.4283 16.969 11.3153 16.856C11.2022 16.7429 11.1457 16.6021 11.1457 16.4334V11.9238H8.85405V16.4334C8.85405 16.6021 8.79733 16.7429 8.68387 16.856C8.57041 16.969 8.4351 17.0256 8.27793 17.0256H4.71468C4.47126 17.0256 4.25923 16.9354 4.07858 16.755C3.89794 16.5747 3.80762 16.3604 3.80762 16.1121Z"
          fill={color ?? "currentColor"}
        />
      </g>
    </svg>
  );
};
